import { getRequest, putRequest } from 'utils/http'

export const getMyFlagsApi = () =>
  getRequest('/feature-flags/me')

export const getUserFlagsApi = userId =>
  getRequest(`/feature-flags/user/${userId}`)

export const setUserFlagApi = ({ userId, flagKey, enabled }) =>
  putRequest(`/feature-flags/user/${userId}/${flagKey}`, {
    enabled
  })
